<template>
    <div
        class="navigation-bar"
        :class="{ 'is-open': isOpen }"
        :style="{
            backgroundColor: authStore.$state.user.company.primary_color,
        }"
    >
        <button
            class="menu-btn"
            @click="$emit('toggle')"
            v-if="
                authStore.$state.user.isAdmin ||
                (authStore.$state.user.isFleet &&
                    authStore.$state.user.hasSearch)
            "
        >
            <i v-show="isOpen" class="fas fa-bars"></i>
            <i v-show="!isOpen" class="fa-solid fa-bars-staggered"></i>
        </button>
        <!-- else , we have a button to go to route index-dashboard -->
        <div>
            <button
                class="menu-btn"
                @click="$router.push({ name: 'index-dashboard' })"
            >
                <i class="fa-solid fa-house"></i>
            </button>
        </div>
        <div
            v-if="
                authStore.$state.user.company.logo !=
                'companies_logo/default.png'
            "
        >
            <img
                :src="
                    $apiUrl() +
                    '/storage/assets/images/companies/' +
                    authStore.$state.user.company.logo
                "
                @error="
                    e => {
                        e.target.src = '/storage/assets/images/default.png';
                    }
                "
                alt="logo"
                class="h-10 w-auto bg-white rounded-full p-1"
            />
        </div>
        <SearchBar
            v-if="
                authStore.$state.user.isAdmin ||
                (authStore.$state.user.isFleet &&
                    authStore.$state.user.hasSearch)
            "
            :isOpen="isOpen"
            class="hidden lg:block"
        />
        <BikeFamousQuotes class="hidden xl:block" />
        <div class="d-flex justify-content-end" style="margin-left: auto">
            <primary-button
                @click="
                    () => {
                        $router.push({
                            name: 'assistance',
                        });
                    }
                "
                style="background-color: #f0ad4e; margin-right: 10px"
            >
                {{
                    $translate('components.dashboard.menu.assistance')
                }}</primary-button
            >
            <UserDropdown :isOpen="isOpen" :user="authStore.$state.user" />
        </div>
    </div>
</template>

<script setup>
import { useAuthStore } from '@/js/stores/authStore';

import BikeFamousQuotes from './BikeFamousQuotes.vue';
import SearchBar from './SearchBar.vue';
import UserDropdown from './UserDropdown.vue';

defineProps({
    isOpen: Boolean,
});

const authStore = useAuthStore();

defineEmits(['toggle']);
</script>

<style lang="scss" scoped>
@use '@/scss/variables' as vars;
.navigation-bar {
    position: fixed;
    width: 100%;
    height: 60px;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0;
    background-color: vars.$greenColor;
    transition: margin-left 0.3s ease-in-out;
    z-index: 2;
    .menu-btn {
        color: vars.$whiteColor;
        font-size: 1.5rem;
        cursor: pointer;
        padding: 1rem;
    }
}
.navigation-bar.is-open {
    margin-left: 300px;
}
</style>
